import React, { useEffect, useState } from 'react';
import styles from './DeathActions.module.css';

interface DeathActionsProps {
  onPlayAgain: () => void;
  onRewindDeath: () => void;
}

const DeathActions: React.FC<DeathActionsProps> = ({ onPlayAgain, onRewindDeath }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Small delay to allow the death animation to complete first
    const timer = setTimeout(() => {
      setVisible(true);
    }, 600);
    
    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  return (
    <div className={styles.container}>
      <div className={styles.buttonWrapper}>
        <button 
          className={`${styles.actionButton} ${styles.rewindButton}`} 
          onClick={onRewindDeath}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '8px' }}>
            <path d="M2.5 2v6h6M2.66 15.57a10 10 0 1 0 .57-8.38"/>
          </svg>
          Rewind Death
        </button>
        <button 
          className={`${styles.actionButton} ${styles.playAgainButton}`} 
          onClick={onPlayAgain}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '8px' }}>
            <polygon points="5 3 19 12 5 21 5 3"></polygon>
          </svg>
          Play Again
        </button>
      </div>
    </div>
  );
};

export default DeathActions; 